/* @flow */
import { remove } from 'lib/queryParams';
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import { browserHistory } from 'react-router';
import type { RouterState } from 'lib/ReactRouterTypes';
import { redirector } from 'auth/components/SignInPage.jsx';

type UserStore = {
  isSignedIn: () => boolean,
};

type Authenticator = {
  checkLoggedInAndLoadAppData: () => Promise<*>,
  accessTokenSignIn: (token: string) => Promise<*>,
};

type Options = { location?: string, userStore?: UserStore, authenticator?: Authenticator };
type OnEnter = (s: RouterState, replace: Function, cb: Function) => void;
type Handler = (s: RouterState, replace: Function, cb: Function, opts?: Options) => void;

const handler: Handler = (state, replace, callback, opts = {}) => {
  const options = {
    location: '/log_in',
    userStore: CurrentUser,
    authenticator: AuthActions,
    ...opts,
  };

  if (options.userStore.isSignedIn()) {
    callback();
    return;
  }

  const redirectToLocation = function() {
    redirector.attemptedTransition = state.location;
    replace(options.location);
    callback();
  };

  if (state.location.query['auth_token']) {
    options.authenticator
      .accessTokenSignIn(state.location.query['auth_token'])
      .then(callback)
      .catch(redirectToLocation)
      .then(() => remove(browserHistory, ['auth_token']))
      .catch(() => console.error('could not clear auth token'));

    return;
  }

  options.authenticator
    .checkLoggedInAndLoadAppData()
    .then(user => {
      if (user) {
        callback();
      } else {
        redirectToLocation();
      }
    })
    .catch(err => {
      console.warn('checkLoggedInAndLoadAppData failed so redirecting to signin page', err);
      redirectToLocation();
    });
};

const RequireUserFn = (opts: Options = {}): OnEnter => (a, b, c) => handler(a, b, c, opts);
const RequireUser = RequireUserFn();

export { RequireUserFn };
export default RequireUser;
